import { Stack } from "@mui/material";

import { useCurrentDashboardContext } from "../../../../Context/useCurrentDashboardContext";
import { getWidgetId } from "../../../../utils/widgets";
import { type EnticementState } from "../../../LensEnticement/types";
import CloudReportCard from "../../Analytics/CloudReportCard";
import { BQLensEnticement } from "../BQEmptyStateDashboard/BQLensEnticement";

const BQInactiveStateDashboard = ({ enticementState }: { enticementState: EnticementState }) => {
  const { currentDashboard } = useCurrentDashboardContext();
  const cloudReportWidget = currentDashboard?.widgets?.find((widget) => widget.name.includes("cloudReports"));

  const widgetId = () => {
    if (cloudReportWidget) {
      return getWidgetId(cloudReportWidget);
    }
  };

  const id = widgetId();
  if (!currentDashboard || !cloudReportWidget || !id) {
    return null;
  }

  return (
    <Stack data-cy="bqEmptyStateDashboard" spacing={5} sx={{ width: "100%", p: 0, mt: "50px" }}>
      <BQLensEnticement state={enticementState} />
      <CloudReportCard widgetId={id} />
    </Stack>
  );
};

export default BQInactiveStateDashboard;
